export default {
  // 钱包余额
  walletBalanceTitle: "钱包地址总余额（USDT）",
  walletBalanceTooltip:
    "钱包地址总资产余额目前暂只统计（ETHEREUM、TRON、BSC、BTC、polygon等五条链地址的余额）\n\n根据本系统已收录的币种价值，按地址持有的所有主币和代币折算USDT的总余额",
  clickToUpdate: "点击右边按钮更新余额",
  update: "更新",
  partialUpdateSuccess: "（部分地址余额更新成功）",

  // 账户总资产
  accountTotalAssets: "账户总资产预览(USDT)",

  // 基础信息
  basicInformation: "基础信息",
  addCharacter: "添加人物",
  viewDetails: "查看详情",
  characterSyncFailed: "人物信息同步失败",

  // 基础信息字段
  userId: "用户ID",
  name: "姓名",
  username: "用户名",
  nationality: "国籍",
  idNumber: "证件号",
  homePlace: "籍贯",
  sex: "性别",
  phone: "手机号",
  email: "邮箱",
  registerTime: "注册时间",
  relatedCase: "关联案件",
  note: "备注",

  // Bitpie 特殊字段
  bindingPhoneTime: "绑定手机时间",
  analysisId: "分析ID",

  // imToken 特殊字段
  deviceId: "设备ID",
  firstUseTime: "首次使用时间",

  // 金融信息
  financialInformation: "金融信息",
  spotTrading: "币币交易",
  paymentInfo: "收款信息",
  walletAddress: "钱包地址",
  usedAddresses: "使用过的地址",
  watchedAddresses: "观察过的地址",

  // 钱包账户
  walletAccount: "钱包账户",
  noBankFound: "暂无查询到相关银行",
  wechat: "微信",
  alipay: "支付宝",

  // 加载更多
  loadMore: "条数据，加载更多",
  collapse: "收起",

  // 状态
  has: "有",
  none: "无",

  // 消息提示
  copySuccess: "复制成功",
};
